import React from 'react'
import styled from 'styled-components'

import GGOOLLFF from '@/assets/images/logo-removebg.png'
import NEVERBE from '@/assets/images/neverbe-removebg.png'
import { useResponsive } from '@/hooks/useResponsive'

const FooterWrapper = styled.footer`
  width: 100%;
  background-color: #f6f7f9;
  border-top: 1px solid #e0e0e0;
  padding: 40px 20px;
`

const FooterLogo = styled.div`
  height: 40px;
  margin: 0px auto;
  max-width: 60%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 5px 0;

  .logo {
    height: 30px;
    margin-right: 10px;
  }

  @media (max-width: 768px) {
    max-width: 100%; // 전체 너비 사용
    margin: 0; // 중앙 정렬 제거
    justify-content: flex-start; // 왼쪽 정렬 유지
    padding-left: 0; // 왼쪽 패딩 제거

    .logo {
      height: 28px;
    }
  }
`

const FooterContent = styled.div`
  max-width: 60%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    max-width: 100%; // 전체 너비 사용
    margin: 0; // 중앙 정렬 제거
    flex-direction: column;
    align-items: flex-start; // 왼쪽 정렬
    gap: 10px;
    padding-left: 0; // 왼쪽 패딩 제거
  }
`

const FooterInfo = styled.div`
  font-size: 0.8125rem;
  color: #636773;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;

  .info-line {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    width: 100%;
    gap: 5px;

    span {
      white-space: nowrap;
    }

    span:not(:last-child)::after {
      content: '|';
      margin: 0 5px;
    }
  }

  .address {
    margin: 5px 0; // 주소 위아래 간격
  }

  @media (max-width: 768px) {
    text-align: left; // 전체 텍스트 왼쪽 정렬
    width: 100%;

    .info-line {
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
      gap: 3px; // 세로 간격 줄이기
    }

    .address {
      text-align: left;
      width: 100%;
    }

    .info-line span:not(:last-child)::after {
      display: none;
    }
  }

  /* 모바일 */
  @media (max-width: 480px) {
    max-width: 100%;
    padding: 0;
  }

  /* 매우 작은 모바일 */
  @media (max-width: 360px) {
    max-width: 100%;
    padding: 0;
  }
`

const FooterCopyright = styled.div`
  font-size: 0.875rem;
  color: #999999;
  text-align: center;
  margin-top: 20px;

  @media (max-width: 768px) {
    text-align: left; // 모바일에서도 왼쪽 정렬
    margin-top: 15px;
  }
`

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;

  a {
    color: #636773;
    font-size: 1.5rem;
    transition: color 0.3s;

    &:hover {
      color: #333333;
    }
  }

  @media (max-width: 768px) {
    justify-content: flex-start;
    width: 100%;
  }
`

const Footer: React.FC = () => {
  const { isMobile, isTablet, isDesktop } = useResponsive()
  return (
    <FooterWrapper>
      <FooterLogo>
        <img className="logo" src={NEVERBE} alt="네버비" />
      </FooterLogo>
      <FooterContent>
        <FooterInfo>
          주식회사 네버비(NEVER BE)
          <br />
          {!isMobile ? (
            <div className="address">
              (07325) 서울특별시 영등포구 의사당대로 83, 여의도동 18층
              (여의도동, 오투타워)
            </div>
          ) : (
            <div className="address">
              (07325) 서울특별시 영등포구 의사당대로 83, <br />
              여의도동 18층 (여의도동, 오투타워)
            </div>
          )}
          <div className="info-line">
            <span>대표 : 이승철</span>
            <span>사업자번호 : 895-86-01610</span>
            <span>Email : neverbe.family@gmail.com</span>
          </div>
        </FooterInfo>
      </FooterContent>
      <FooterCopyright>
        Copyright © 2025 NEVER BE Corp. All Rights Reserved.
      </FooterCopyright>
    </FooterWrapper>
  )
}

export default Footer
